import { apiTranslations } from './domains/api';
import { authTranslations } from './domains/auth';
import { allocationsTranslations } from './domains/allocations';
import { bankTranslations } from './domains/bank';
import { adminTranslations } from './domains/admin';
import { anomaliesTranslations } from './domains/anomalies';
import { auditTranslations } from './domains/audit';
import { commonTranslations } from './domains/common';
import { correctionsTranslations } from './domains/corrections';
import { matchingTranslations } from './domains/matching';
import { paymentCandidatesTranslations, transactionsTranslations } from './domains/paymentCandidates';
import { platformTranslations } from './domains/platform';
import { settingsTranslations } from './domains/settings';
import { sharedTranslations } from './domains/shared';
import { statusTranslations } from './domains/status';
import { syrveTranslations } from './domains/syrve';
import { workbenchV1Translations } from './domains/workbenchV1';
import { workbenchV2Translations } from './domains/workbenchV2';
import { baseTranslations } from './translations.base';
import type { Locale, TranslationMap } from './types';

export const translations: Record<Locale, TranslationMap> = {
  ru: {
    ...baseTranslations.ru,
    ...authTranslations.ru,
    ...commonTranslations.ru,
    ...matchingTranslations.ru,
    ...syrveTranslations.ru,
    ...allocationsTranslations.ru,
    ...bankTranslations.ru,
    ...settingsTranslations.ru,
    ...adminTranslations.ru,
    ...platformTranslations.ru,
    ...auditTranslations.ru,
    ...anomaliesTranslations.ru,
    ...correctionsTranslations.ru,
    ...paymentCandidatesTranslations.ru,
    ...transactionsTranslations.ru,
    ...statusTranslations.ru,
    ...apiTranslations.ru,
    ...sharedTranslations.ru,
    ...workbenchV1Translations.ru,
    ...workbenchV2Translations.ru,
  } as TranslationMap,
  en: {
    ...baseTranslations.en,
    ...authTranslations.en,
    ...commonTranslations.en,
    ...matchingTranslations.en,
    ...syrveTranslations.en,
    ...allocationsTranslations.en,
    ...bankTranslations.en,
    ...settingsTranslations.en,
    ...adminTranslations.en,
    ...platformTranslations.en,
    ...auditTranslations.en,
    ...anomaliesTranslations.en,
    ...correctionsTranslations.en,
    ...paymentCandidatesTranslations.en,
    ...transactionsTranslations.en,
    ...statusTranslations.en,
    ...apiTranslations.en,
    ...sharedTranslations.en,
    ...workbenchV1Translations.en,
    ...workbenchV2Translations.en,
  } as TranslationMap,
  id: {
    ...baseTranslations.id,
    ...authTranslations.id,
    ...commonTranslations.id,
    ...matchingTranslations.id,
    ...syrveTranslations.id,
    ...allocationsTranslations.id,
    ...bankTranslations.id,
    ...settingsTranslations.id,
    ...adminTranslations.id,
    ...platformTranslations.id,
    ...auditTranslations.id,
    ...anomaliesTranslations.id,
    ...correctionsTranslations.id,
    ...paymentCandidatesTranslations.id,
    ...transactionsTranslations.id,
    ...statusTranslations.id,
    ...apiTranslations.id,
    ...sharedTranslations.id,
    ...workbenchV1Translations.id,
    ...workbenchV2Translations.id,
  } as TranslationMap,
};
